import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { IAvailableTypes } from 'src/app/core/models/available-types.interface';
import { ICategory } from 'src/app/core/models/category.interface';
import { PageParams } from 'src/app/core/models/page-params.model';
import { CategoriesService } from 'src/app/core/services/categories.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { UserService } from 'src/app/core/services/user.service';
import { IProduct, ISOProduct } from 'src/app/modules/customers-order-management/models/order-details.model';
import { ISaleOrder } from '../../../models/sale-order.interface';
import { SaleOrderService } from '../../../services/sale-order.service';
import { SaleProductService } from '../../../services/sale-product.service';
import { ProductPopupDialog } from 'src/app/shared/popups/product-popup/product-popup.component';
import { ProductPopupTableComponent } from 'src/app/shared/popups/product-popup-table/product-popup-table.component';

@Component({
  selector: 'eci-goods-list',
  templateUrl: './goods-list.component.html',
  styleUrls: ['./goods-list.component.scss']
})
export class GoodsListComponent implements OnInit, OnChanges {

  pageParams: PageParams = new PageParams();

  productList: IProduct[] = []; // ISOProduct[] = []
  @Input() orderId: number;
  @Input() info: ISaleOrder;
  @Input() isCreateMode: boolean = true;
  @Input() isMarketplaceSO: boolean = false;
  @Input() isB2BSaleOrder: boolean = false;
  @Input() availableTypes: IAvailableTypes;
  @Input() availableFields: string[];
  @Input() hasError: boolean;
  @Input() creationType: string = 'single';
  @Input() isEditable: boolean = true;
  isEcommarceSO: boolean = false;
  @Output() reloadEmit: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Input() isAdmin: boolean = false;
  @Input() selectedShop: any;
  @Input() originCountry: any;
  showLoader: boolean = false;

  availableCategories: ICategory[];
  currentSort: Sort;

  @Output() infoChange = new EventEmitter<ISaleOrder>();
  @Output() hasErrorChange = new EventEmitter<boolean>();

  pageChanged(e: PageParams): void {
    this.pageParams.pageIndex = e.pageIndex;
    this.pageParams.pageSize = e.pageSize;
    this.getList(this.info.id, e.pageIndex + 1, e.pageSize);
  }

  constructor(
    private dialog: MatDialog,
    public userSvc: UserService,
    private categoriesSvc: CategoriesService,
    private saleProductSvc: SaleProductService,
    private notify: NotificationService,
    private saleOrderSvc: SaleOrderService,
    private changeDetectorRef: ChangeDetectorRef,
  ) { }

  displayedColumns: string[] = [
      'productName',
      'itemNumber',
      'units',
      'totalPrice',
      // 'category',
      // 'weight',
      // 'volume',
  ];

  public dataSource: MatTableDataSource<IProduct> = new MatTableDataSource<IProduct>([]);

  ngOnInit(): void {
    // Api call to get the products to initialize the pagination for products.
    if (!!this.info?.id) {
      this.getList(this.info?.id, 1, 100);
    }
    if (!this.isCreateMode) {
      let colsArr: any = [
        'totalAfterDiscount',
        'totalDiscount',
        'hsCode',
        // 'taxRate',
        // 'taxAmount',
      ];
      this.displayedColumns.push(...colsArr);
    }
    this.isEcommarceSO = this.info?.subtagMsg === 'ecommerce';
    this.productList = !this.isCreateMode || this.info?.isDraft ? this.info?.products : [];
    this.dataSource.data = !this.isCreateMode || this.info?.isDraft ? this.info?.products : [];
    this.categoriesSvc.getAvailableCategories().subscribe((data) => {
      this.availableCategories = data.items;
    });

    if (!this.isCreateMode) {
      this.displayedColumns.push('category');
      // this.displayedColumns.push('simplyDutyCategory');
    }
    this.hasErrorChange.emit(this.productList.length < 1);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((!this.isCreateMode || this.info?.isDraft) && changes['info']) {
      this.dataSource.data = this.info?.products;
    }
  }

  getList(
    orderId: number = this.orderId,
    page: number = 1,
    limit: number = 100,
    q: string = '',
    orderField: string = this.currentSort?.active || '',
    orderDir: string = this.currentSort?.direction.toUpperCase() || ''): void {
    this.saleProductSvc.getOrderProducts(orderId, page, limit, q, orderField, orderDir).subscribe(data => {
      if (!data && !Array.isArray(data.items)) return;
      this.dataSource.data = [...data.items];
      this.productList = data.items;
      this.pageParams.pageSize = data.meta.itemsPerPage;
      this.pageParams.pageIndex = data.meta.currentPage - 1;
      this.pageParams.length = data.meta.totalItems;
    })
  }

  openDialog(): void {
    if (!this.info?.companyId) {
      this.notify.showWarn("Please choose company first");
      return;
    }

    // if (!this.originCountry) {
    //   this.notify.showWarn("Please choose origin country");
    //   return;
    // } // Comment this for now, as it is not required - ##6459.

    if (this.isMarketplaceSO && !this.selectedShop) {
        this.notify.showWarn("Please choose shop first");
        return;
    }
    const dialogRef = this.dialog.open(ProductPopupTableComponent, {
      maxHeight: '600px',
      data: {
        isCreateMode: this.isCreateMode,
        isSaleOrder: true,
        companyId: this.info?.companyId,
        isB2BSaleOrder: this.isB2BSaleOrder || this.info?.isB2B,
        isMarketplaceSO: this.info?.isEmpact || this.isMarketplaceSO,
        shopId: this.selectedShop?.shopId,
        country: this.originCountry
      }
    });
    dialogRef.componentInstance.title = "Sale Order - Add Product";

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }
      const products = Array.isArray(result.info) ? result.info : [result.info];
      const modelsToShow = Array.isArray(result.modelToShow) ? result.modelToShow : [result.modelToShow];
      this.productList.push(...products);
      this.dataSource.data = [...(this.dataSource?.data || []), ...modelsToShow];
      this.info = this.model;
      if (this.info?.isEmpact) {
         this.info.eciTotal = this.calcTotal;
      }
      this.infoChange.emit(this.info);
      this.hasErrorChange.emit(this.productList.length < 1);
    });
  }

    get calcTotal(): number {
        return this.productList?.reduce((sum, el) => sum + (+el.total || (el.units * (el.price - (el.price / 100 * (el.discount || 0))))), 0);
    }

  public openDialogLocal(productToEdit: IProduct): void {
    if (this.isEcommarceSO) {
      return;
    }
    const dialogRef = this.dialog.open(ProductPopupDialog, {
      maxHeight: '600px',
      data: {
        isCreateMode: this.isCreateMode,
        isEditable: this.isEditable,
        isSaleOrder: true,
        companyId: this.info?.companyId,
        isB2BSaleOrder: this.isB2BSaleOrder || this.info?.isB2B,
        isMarketplaceSO: this.info?.isEmpact || this.isMarketplaceSO,
      }
    });

    dialogRef.componentInstance.info = productToEdit;
    dialogRef.componentInstance.availableCategories = this.availableCategories;
    dialogRef.componentInstance.title = 'Sale Order - Add Product';

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }
      if (!this.isCreateMode || this.info.isDraft) {
          this.updateProduct(result.info);
      } else {
          const index = this.productList.findIndex((product: IProduct) => product.productId === productToEdit.productId);
          this.productList[index] = result.info;
          const tableData = this.dataSource.data;
          tableData[index] = result.modelToShow;
          this.dataSource.data = tableData;
          this.info = this.model;
          if (this.info?.isEmpact) {
              this.info.eciTotal = this.calcTotal;
          }
          this.infoChange.emit(this.info);
      }
    });
  }

  private updateProduct(value): void {
    this.saleProductSvc.updateOrder(value.id, value).subscribe(_ => {
      this.getList(this.info.id);
    });
  }

  get model(): ISaleOrder {
    return {
      ...this.info,
      products: this.productList,
    }
  }

  findCategoryName(id): string {
    if (!this.availableCategories) return;
    const category = this.availableCategories.find(el => el.id == id);
    return category ? category.name : '';
  }

  sortData(sort: Sort): void {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      this.productList = data;
      this.dataSource = new MatTableDataSource<IProduct>(data);
      return;
    }
    if (this.isCreateMode) {
      this.localSort(sort, data);
      return;
    }
    this.currentSort = sort;
    this.getList(this.info.id);
  }

    regenerateInvoice() {
        this.showLoader = true;
        const ids: number[] = [];
        ids.push(this.info.id);
        this.saleOrderSvc.regenrateOrdersInvoice(ids).subscribe((data) => {
            this.notify.showSuccessMessage('Invoice Regenerated successfully');
            this.reloadEmit.emit(true);
            this.showLoader = false;
        }, (err) => {
            this.showLoader = false;
            this.notify.showError('Something went wrong');
        });
    }

  localSort(sort: Sort, data: any): void {
    this.dataSource = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'units': return compare(a.units, b.units, isAsc);
        case 'itemNumber': return compare(a.itemNumber, b.itemNumber, isAsc);
        case 'category': return compare(a.categoryId, b.categoryId, isAsc);
        case 'hsCode': return compare(a.hsCode, b.hsCode, isAsc);
        case 'weight': return compare(a.weight, b.weight, isAsc);
        case 'volume': return compare(a.volume, b.volume, isAsc);
        default: return 0;
      }
    });

    this.dataSource = new MatTableDataSource<IProduct>(this.dataSource.data);
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
